import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import languageContext from "../context/language/languageContext";
import Navbar from "../components/Navbar";
import {API_URL,FAST_API_URL} from "../api"


const PatientDashboard = () => {
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

  // Chat
  const [chatOpen, setChatOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [sending, setSending] = useState(false);

  // 🔥 NEW STATES (Extend Plan)
  const [showExtendModal, setShowExtendModal] = useState(false);
  const [extendDays, setExtendDays] = useState(3);
  const [extending, setExtending] = useState(false);

  const { setSessionTimeout } = useContext(languageContext);

  useEffect(() => {
    fetchTodayPlan();
  }, []);

  // Normalize instructions
  const normalizeInstructions = (instructions = []) => {
    return instructions.map((item) => {
      if (typeof item === "object") {
        return {
          medicine: item.medicine || "Medicine",
          dosage: item.dosage || "",
          timing: item.timing || "",
          precautions: item.precautions || "",
        };
      }
      return {
        medicine: item,
        dosage: item,
        timing: "",
        precautions: "",
      };
    });
  };

  // Fetch plan
//   const fetchTodayPlan = async () => {
//   try {
//     const res = await axios.post(
//       `${API_URL}/next-day",
//       null,
//       {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       }
//     );

//     setPlan(res.data);
//     setLoading(false);

//     // Random question
//     if (res.data?.plan?.check_in_questions?.length) {
//       const questions = res.data.plan.check_in_questions;
//       const random =
//         questions[Math.floor(Math.random() * questions.length)];

//       setMessages([{ type: "bot", text: random }]);
//     }

//   } catch (err) {
//     // 🔥 TOKEN EXPIRED
//     if (err.response?.data?.detail === "Token has expired") {
//       setSessionTimeout(true);
//       return;
//     }

//     // 🔥 NO PLAN (IMPORTANT FIX)
//     if (err.response?.status === 404) {
//       setPlan(null);       // 👈 VERY IMPORTANT
//       setLoading(false);
//       return;
//     }

//     // 🔁 ONLY retry for server errors
//     setTimeout(fetchTodayPlan, 2000);
//   }
// };
const fetchTodayPlan = async () => {
  try {
    const res = await axios.post(
      `${API_URL}/next-day`,
      null,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    setPlan(res.data);
    setLoading(false);

    // ✅ Random question
    if (res.data?.plan?.check_in_questions?.length) {

      const questions =
        res.data.plan.check_in_questions;

      const random =
        questions[
          Math.floor(Math.random() * questions.length)
        ];

      setMessages([
        {
          type: "bot",
          text: random,
        },
      ]);
    }

  } catch (err) {

    console.error(err);

    // =========================
    // 🔥 TOKEN EXPIRED
    // =========================
    if (
      err.response?.data?.detail ===
      "Token has expired"
    ) {
      setSessionTimeout(true);
      return;
    }

    // =========================
    // 🔒 SUBSCRIPTION REQUIRED
    // =========================
    if (err.response?.status === 402) {

      if (
        err.response?.data?.subscription_required
      ) {

        alert(
          err.response?.data?.error ||
          "Subscription required"
        );

        // 👉 open subscription modal/page
        navigate("/subscription");

        setLoading(false);
        return;
      }
    }

    // =========================
    // ❌ NO PLAN
    // =========================
    if (err.response?.status === 404) {

      setPlan(null);
      setLoading(false);

      return;
    }

    // =========================
    // ❌ OTHER API ERRORS
    // =========================
    if (err.response?.data?.error) {

      alert(err.response.data.error);

      setLoading(false);
      return;
    }

    // =========================
    // 🔁 RETRY ONLY SERVER ERRORS
    // =========================
    if (
      err.response?.status >= 500 ||
      !err.response
    ) {

      setTimeout(fetchTodayPlan, 2000);
    }

    setLoading(false);
  }
};

  // 🔥 EXTEND PLAN API
  const extendPlan = async () => {
    if (!extendDays || extendDays <= 0) {
      alert("Enter valid days");
      return;
    }

    setExtending(true);

    try {
      await axios.post(
        `${API_URL}/extend-plan-ai`,
        {
          plan_id: plan.plan_id,
          days: extendDays,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      setShowExtendModal(false);
      setExtendDays(3);

      fetchTodayPlan();

    } catch (err) {
      alert(err.response?.data?.error || "Extension failed");
    }

    setExtending(false);
  };

  // Chat
  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMsg = input;

    setMessages((prev) => [...prev, { type: "user", text: userMsg }]);
    setInput("");
    setSending(true);

    try {
      const res = await axios.post(
        `${API_URL}/daily-chatbot-response`,
        { message: userMsg },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      setMessages((prev) => [
        ...prev,
        { type: "bot", text: res.data.reply },
      ]);
    } catch {
      setMessages((prev) => [
        ...prev,
        { type: "bot", text: "⚠️ Something went wrong" },
      ]);
    }

    setSending(false);
  };

  // 🔥 NO PLAN UI
if (!loading && !plan) {
  return (
    <div className="flex flex-col h-[100vh]">
      <Navbar />

      <div className="flex flex-col items-center justify-center flex-1 text-center px-4">

        <h2 className="text-2xl font-semibold mb-2">
          No Plan Found
        </h2>

        <p className="text-gray-500 mb-4">
          You haven't generated a plan yet.
        </p>

      </div>x
    </div>
  );
}

  const safeInstructions = normalizeInstructions(plan?.plan?.instructions);
  const safePlan = plan?.plan || {};

  const day = plan?.day || 0;
 const remaining = plan?.remaining_days || 0;

const totalDays = day + remaining || 1;   // avoid divide by 0
const progress = totalDays > 0 ? (day / totalDays) * 100 : 0;
  return (
    <div className="flex flex-col h-[100vh]">
      <Navbar />

      <div className="min-h-screen bg-gray-50 p-6">
        <div className="max-w-3xl mx-auto">

          {/* Header */}
          <div className="flex justify-between items-center mb-6">
            <div>
              <h1 className="text-3xl font-bold">🩺 Day {day}</h1>
              <p className="text-sm text-gray-500">
                {remaining > 0
                  ? `Keep going! ${plan.remaining_days} days left 💪`
                  : "🎉 Treatment Completed"}
              </p>
            </div>

            <div className="flex items-center gap-3">
              <div className="text-right">
                <p className="text-sm text-gray-500">Remaining</p>
                <p className="text-lg font-semibold text-blue-600">
                  {remaining} days
                </p>
              </div>

              {/* 🔥 EXTEND BUTTON */}
              <button
                onClick={() => setShowExtendModal(true)}
                className="bg-green-600 text-white px-3 py-2 rounded-lg text-sm"
              >
                Extend
              </button>
            </div>
          </div>

          {/* Progress */}
          <div className="bg-gray-200 h-2 rounded mb-2">
            <div
              className="bg-blue-500 h-2 rounded"
              style={{ width: `${progress}%` }}
            />
          </div>

          <div className="flex justify-between text-xs text-gray-500 mb-6">
            <span>Day 1</span>
            <span>Day {totalDays}</span>
          </div>

          {/* Completed */}
          {remaining === 0 && (
            <div className="bg-green-100 text-green-700 p-4 rounded-lg text-center mb-6">
              ✅ Treatment Completed
            </div>
          )}

          {/* Card */}
          <div className="bg-white p-6 rounded-2xl shadow-lg space-y-6">

            <div>
              <h3 className="text-blue-600 font-semibold">Focus</h3>
              <p>{safePlan.focus}</p>
            </div>

            <div>
              <h3 className="text-green-600 font-semibold">💊 Medicines</h3>
              {safeInstructions.map((m, i) => (
                <div key={i} className="bg-green-50 p-3 rounded-lg mt-2">
                  <p>{m.medicine}</p>
                  <p className="text-sm">{m.dosage}</p>
                  <p>{m.timing}</p>
                  <p className="text-sm">{m.precautions}</p>
                </div>
              ))}
            </div>

            <div>
              <h3 className="text-purple-600 font-semibold">❓ Questions</h3>
              <ul>
                {safePlan.check_in_questions?.map((q, i) => (
                  <li key={i}>• {q}</li>
                ))}
              </ul>
            </div>

          </div>

          <div className="mt-6 text-center text-gray-500">
            Remaining Days: {remaining}
          </div>
        </div>

        {/* Chat Button */}
        <button
          onClick={() => setChatOpen(true)}
          className="fixed bottom-6 right-6 bg-blue-600 text-white p-4 rounded-full shadow-xl"
        >
          💬
        </button>

        {/* Chat Panel */}
        {chatOpen && (
          <div className="fixed bottom-0 right-0 w-full sm:w-96 h-[80vh] bg-white shadow-2xl rounded-t-2xl flex flex-col">

            <div className="bg-blue-600 text-white p-4 flex justify-between">
              <span>🩺 Health Assistant</span>
              <button onClick={() => setChatOpen(false)}>✖</button>
            </div>

            <div className="flex-1 overflow-y-auto p-4 space-y-3 bg-gray-50">
              {messages.map((m, i) => (
                <div
                  key={i}
                  className={`p-3 rounded-xl max-w-[80%] ${
                    m.type === "user"
                      ? "bg-blue-500 text-white ml-auto"
                      : "bg-white shadow"
                  }`}
                >
                  {m.text}
                </div>
              ))}
              {sending && <p className="text-gray-400 text-sm">Typing...</p>}
            </div>

            <div className="p-3 border-t flex gap-2">
              <input
                value={input}
                onChange={(e) => setInput(e.target.value)}
                className="flex-1 border px-3 py-2 rounded-lg"
                placeholder="Ask anything..."
              />
              <button
                onClick={sendMessage}
                className="bg-blue-600 text-white px-4 rounded-lg"
              >
                Send
              </button>
            </div>

          </div>
        )}

        {/* 🔥 MODAL */}
        {showExtendModal && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">

            <div className="bg-white p-6 rounded-xl w-80">

              <h2 className="text-lg font-semibold mb-3 text-center">
                Extend Plan
              </h2>

              <input
                type="number"
                value={extendDays}
                onChange={(e) => setExtendDays(e.target.value)}
                className="w-full border px-3 py-2 rounded mb-4"
                placeholder="Enter days"
                min={1}
                max={7}
              />

              <div className="flex gap-2">
                <button
                  onClick={() => setShowExtendModal(false)}
                  className="w-full bg-gray-300 py-2 rounded"
                >
                  Cancel
                </button>

                <button
                  onClick={extendPlan}
                  disabled={extending}
                  className="w-full bg-green-600 text-white py-2 rounded"
                >
                  {extending ? "..." : "Extend"}
                </button>
              </div>

            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default PatientDashboard;